import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import LightSpinnerWrapper from '../../reusable/Wrappers/LightSpinnerWrapper/LightSpinnerWrapper.jsx';
import api from '../../api/EditThirdParty.api';
import headerActions from '../../reusable/Header/Header.actions';
import xhr from './../../utils/xhr';
import { withRouter } from 'react-router';
import DeliveryIcons from '../../reusable/DeliveryIcons/DeliveryIcons';
import storage from "../../utils/storage";
import utils from "../../utils/utilities";

class ExperianFullDoc extends React.Component {

    static propTypes = {
        experianId: PropTypes.string,
        companyId: PropTypes.string,
    }

    constructor(props) {
        super(props);

        this.state = {
            experianResponse: null
        }

        this.goBack = this.goBack.bind(this);
    }

    componentWillMount() {
        headerActions.updateHeader('experianReportPage');

        this.fetchExperianData()
    }

    fetchExperianData() {
        return api.queryExperianId(this.props.params.experianId).then((response) => {
            let auth = storage.getObject("lnei");
            let isWam = (auth && auth.authInfo && auth.authInfo.type === "WAM");

            if (isWam) {
                const body      = response.body.htmlDoc;

                let el = document.createElement( 'html' );
                el.innerHTML = `<html>${response.text}</html>`;

                let parsed = utils.parseBySections(el);

                const title     = parsed["organizationName"];
                const company   = parsed["organizationName"];
                const address   = parsed["address"];
                const loadDate  = parsed["date"];


                this.setState({
                    experianResponse: { title, body, company, loadDate, address, success: true }
                })
            } else {
                let el = document.createElement( 'html' );
                el.innerHTML = `<html>${response.text}</html>`;

                const body      = response.text;
                const title     = el.getElementsByTagName("title")[0].innerText;
                const company   = el.getElementsByClassName("PUB-COMPANY")[0].innerText;
                const address   = el.getElementsByClassName("DISPLAY-ADDR1")[0].innerText;
                const loadDate   = el.getElementsByClassName("LOAD-DATE")[0].innerText.replace("LOAD-DATE", "Load Date");

                this.setState({
                    experianResponse: { title, body, company, loadDate, address, success: true }
                })
            }

        }).catch((error) => {
            if (error.response && error.response.status === 500) {
                this.setState({experianResponse: {success: false, statusCode: error.response.status}});
            } else {
                xhr.handleAllErrors(error);
                this.setState({
                    experianResponse: { success: false }
                })
            }
        });
    }

    goBack() {
        this.props.router.goBack();
    }

    render() {

        if (this.state.experianResponse && this.state.experianResponse.success === false) {
            return (
                <div id="experian-document">
                    <div className="view-article-page">
                            <span className="back-to-previous-page" onClick={this.goBack}>
                                <span className="la-TriangleLeft"></span>
                                <span className="text">
                                    <FormattedMessage
                                        id="General_CoreFunctionality_UIText_general.backToPreviousPage" />
                                </span>
                            </span>
                        <div className='experian-error'>
                            <FormattedMessage id='Entities_Dossier_UIText_dossierServiceUnavailable' />
                        </div>
                    </div>
                </div>
            )
        }

        return (
            <LightSpinnerWrapper isLoading={this.state.experianResponse === null}>
                <div id="experian-document">
                    <div className="view-article-page">

                        <span className="back-to-previous-page" onClick={this.goBack}>
                            <span className="la-TriangleLeft"></span>
                            <span className="text">
                                <FormattedMessage id="General_CoreFunctionality_UIText_general.backToPreviousPage" />
                            </span>
                        </span>

                        {this.state.experianResponse && this.state.experianResponse.success && (
                            <div>
                                <h1 className="notranslate">{this.state.experianResponse.title}</h1>
                                <DeliveryIcons experianHtml={this.state.experianResponse.body}/>
                                <div className="preview-article-page">
                                    <div className="experian-response article-body" dangerouslySetInnerHTML={{__html: this.state.experianResponse.body}} />
                                    <div className="notranslate article-details">
                                        <div className="section-title">
                                            <FormattedMessage id="Entities_Preview_UIText_previewCompanies.articleView.sectionAboutArticle"/>
                                        </div>
                                        <div className="load-date">
                                            {this.state.experianResponse.loadDate}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </LightSpinnerWrapper>
        );

    }

}

export default withRouter(ExperianFullDoc);



// WEBPACK FOOTER //
// ./src/scripts/pages/ExperianFullDoc/ExperianFullDoc.jsx